/**
 * Unit tab sub-navigation: Spots | Appliances | Guide clips | Checks (Parts joins when it is built).
 * One chip row with counts; scrolls sideways on a phone.
 */
import { cn } from "@/lib/utils";

export type UnitSub = "spots" | "parts" | "appliances" | "guide" | "checks";

export function UnitSubTabs({
  value,
  counts,
  onChange,
}: {
  value: UnitSub;
  counts: Record<UnitSub, number | null>;
  onChange: (v: UnitSub) => void;
}) {
  const tabs: { id: UnitSub; label: string }[] = [
    { id: "spots", label: "Spots" },
    { id: "parts", label: "Parts" },
    { id: "appliances", label: "Appliances" },
    { id: "guide", label: "Guide clips" },
    { id: "checks", label: "Checks" },
  ];
  return (
    <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" role="tablist">
      {tabs.map((t) => {
        const on = value === t.id;
        const n = counts[t.id];
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onChange(t.id)}
            className={cn(
              "flex h-11 shrink-0 items-center gap-2 rounded-full px-4 text-[15px] font-bold transition-colors",
              on ? "bg-[#15776d] text-white" : "bg-white text-[#0f1720] hover:bg-[#eef3f5]",
            )}
          >
            {t.label}
            {n != null ? (
              <span className={cn("rounded-full px-2 py-0.5 text-[12.5px] font-bold", on ? "bg-white/20 text-white" : "bg-[#eef2f5] text-[#64748b]")}>
                {n}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
